/*
  URL example: /collections/whats-new/blue
  A few things need to happen when a third-level value is detected in the PLP URL:
  - Update the page title (done in Liquid snippets/meta-tags.liquid) - Currently disabled
  - Update the H1 tag value (done in Liquid sections/collection-grid.liquid) - Currently disabled
  - Update the PLP schema (done in snippets/collection-structured-data.liquid)
  - Apply the color with the original Nosto API call
  - Load the correct end of page SEO data
*/
export default () => {
  window.localStorage.removeItem('wild-third-level-url');
  // window.localStorage.removeItem('wild-custom-filter-color');

  // const url_parts = _.compact(window.location.pathname.split('/'));
  const url_parts = window.location.pathname.split('/').filter(Boolean);
  if (url_parts.length < 3) {
    return;
  }

  let url_color_attribute = '';

  // /collections/dresses/red
  if (url_parts[0] === 'collections') {
    url_color_attribute = url_parts[2];
  }

  // /en-gb/collections/dresses/red
  if (url_parts[1] === 'collections' && url_parts.length > 3) {
    url_color_attribute = url_parts[3];
  }

  window.localStorage.setItem('wild-third-level-url', url_color_attribute.toLowerCase());

  /*
  let selected_color_family = [];

  // Only color families are supported for now
  // Making sure the 3rd level item is a color family.
  if (typeof window.theme.collections !== 'undefined' && typeof window.theme.collections.color_families_all !== 'undefined' && window.theme.collections.color_families_all.length) {
    const color_family_found = _.find(window.theme.collections.color_families_all, { family: { color_handle: url_third_attribute } });

    // Assign all child colors
    if (typeof color_family_found !== 'undefined') {
      selected_color_family = url_third_attribute;
      selected_color_family = color_family_found.related_colors.map(color_family => {
        return color_family.title;
      });
    }
  }
  
  if (selected_color_family.length) {
    window.localStorage.setItem('wild-third-level-url', url_third_attribute);
    window.localStorage.setItem('wild-custom-filter-color', selected_color_family);
  } else {
    window.localStorage.setItem('wild-third-level-url', '');
    window.localStorage.setItem('wild-custom-filter-color', '');
  }
  */
};
